import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table, Card } from 'antd';

import PbaSecuritiesForm from '../../forms/PbaSecuritiesForm';

import QUERY from '../../graphql/queries/getCustomerPbaQuery.graphql';

const { Column } = Table;

const PbaSecurities = (props) => {
  const { loading } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const { customerPba: { bank_name, securities } } = props.data;
  return (
    <div>
      <h2 className="page-title">Factsheet - Present Banking Arrangements: Securities</h2>
      <Card title={`All Securities for ${bank_name}`} bordered={false} className="ec-card">
        <Table dataSource={securities} rowKey="id">
          <Column
            title="Address"
            key="address"
            render={(text, record) => (
              <span>
                {record.address}
                <br />
                {record.city}, {record.state} - {record.pincode}
              </span>
            )}
          />
          <Column
            title="Property type"
            dataIndex="property_type"
            key="property_type"
          />
          <Column
            title="Owned By"
            dataIndex="owned_by"
            key="owned_by"
          />
          <Column
            title="Valuation"
            dataIndex="valuation"
            key="valuation"
          />
        </Table>
      </Card>
      <Card title={`Add new security for ${bank_name}`} bordered={false} className="ec-card">
        <PbaSecuritiesForm pba_id={props.match.params.pba_id} />
      </Card>
    </div>
  );
};

PbaSecurities.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerPba: PropTypes.object,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      pba_id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({ variables: { id: match.params.pba_id } }),
})(PbaSecurities);



// WEBPACK FOOTER //
// ./src/pages/factsheet/PbaSecurities.jsx